import { api, getQueryString } from "../common/utils"
import {
  RATE_CARDS_CONFIG_ENDPOINT,
  RATE_CARDS_CONFIGS_ENDPOINT,
  PROFILE_PREFERENCE_MAP_ENDPOINT,
  PROFILE_PREFERENCES_MAP_ENDPOINT
} from "../common/constants"
import {
  RateCardsConfig,
  RateCardsConfigDetails,
  RateCardsConfigDetailsData,
  RateCardsConfigResponse,
  RateCardsConfigUpsertPayload,
  ScenarioPreferenceMapResponse,
  ScenarioPreferenceUpdatePayload
} from "../types"

const rateCards = {
  getRateCardsConfigs: async (params: {
    brand_id?: string
  }): Promise<RateCardsConfig[]> => {
    const { data } = await api.get(
      `${RATE_CARDS_CONFIGS_ENDPOINT}${getQueryString(params)}`
    )
    return data
  },
  getRateCardsConfig: async (id: string): Promise<RateCardsConfigDetails> => {
    const { data } = await api.get<RateCardsConfigResponse>(
      `${RATE_CARDS_CONFIG_ENDPOINT}${getQueryString({ id })}`
    )
    return {
      ...data,
      brand_id: Number(data.brand_id)
    }
  },
  /**
   * The config an embed actually renders for this integration: the one bound
   * in its settings, else the brand default, else the generic default. Same
   * resolution the public embed endpoint uses, so the result may have no id.
   */
  getIntegrationRateCardsConfig: async (
    appKey: string
  ): Promise<{ id?: string; details: RateCardsConfigDetailsData }> => {
    const { data } = await api.get(
      `${RATE_CARDS_CONFIG_ENDPOINT}${getQueryString({ app_key: appKey })}`
    )
    return data
  },
  updateRateCardsConfig: async (
    payload: RateCardsConfigUpsertPayload
  ): Promise<{ status: string; message?: string }> => {
    const { data } = await api.post(RATE_CARDS_CONFIG_ENDPOINT, payload)
    return data
  },
  deleteRateCardsConfig: async (
    id: string
  ): Promise<{ status: string; message?: string }> => {
    const { data } = await api.delete(`${RATE_CARDS_CONFIG_ENDPOINT}?id=${id}`)
    return data
  },
  getProfilePreferenceMap: async (
    brandId: string
  ): Promise<ScenarioPreferenceMapResponse> => {
    const { data } = await api.get(
      `${PROFILE_PREFERENCE_MAP_ENDPOINT}${getQueryString({
        brand_id: brandId
      })}`
    )
    return data
  },
  updateProfilePreferenceMap: async (
    payload: ScenarioPreferenceUpdatePayload
  ): Promise<{ status: string; message?: string }> => {
    const { data } = await api.post(PROFILE_PREFERENCES_MAP_ENDPOINT, payload)
    return data
  }
}

export default rateCards
